import { render, staticRenderFns } from "./HiddenTabsModal.vue?vue&type=template&id=2d376db4&scoped=true&"
import script from "./HiddenTabsModal.vue?vue&type=script&lang=js&"
export * from "./HiddenTabsModal.vue?vue&type=script&lang=js&"
import style0 from "./HiddenTabsModal.vue?vue&type=style&index=0&id=2d376db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d376db4",
  null
  
)

export default component.exports